import {analyticsLogEvent} from '../api'

interface OpenCloseParams {
    action: 'open' | 'close'
    productId: string
    fromStickybar?: boolean
    isZoomOpen?: boolean
}

interface SizeSelectParams {
    productId: string
    selectedSizeId: string
    fromStickybar?: boolean
    isZoomOpen?: boolean
}

/**
 * Tracks the opening and closing of the size selector drawer in the PDP.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel} params.label - Analytics product ID.
 */
export function analyticsProductSizeSelectorOpenClose({action, productId, fromStickybar = false, isZoomOpen = false}: OpenCloseParams) {
    const eventDetails = {
        eventCategory: 'Size Selector',
        eventAction: action,
        eventLabel: productId,
        buttonType: 'Select Size',
        // accessType must be symmetric across open / close / size select
        accessType: fromStickybar ? (isZoomOpen ? 'pdp-sticky-bottom-zoom' : 'pdp-sticky-bottom') : 'pdp',
    }

    analyticsLogEvent('custom_event', eventDetails)
}

/**
 * Tracks the selection of a size from the size selector drawer in the PDP.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.productId - Analytics product ID.
 * @param {EventCustomLabel} params.selectedSizeId - ID of the selected size.
 */
export function analyticsProductSizeSelectorSizeSelect({productId, selectedSizeId, fromStickybar = false, isZoomOpen = false}: SizeSelectParams) {
    const eventDetails = {
        eventCategory: 'Size Selector',
        eventAction: 'size select',
        eventLabel: `${productId} - ${selectedSizeId}`,
        // accessType must be symmetric across open / close / size select
        accessType: fromStickybar ? (isZoomOpen ? 'pdp-sticky-bottom-zoom' : 'pdp-sticky-bottom') : 'pdp',
        buttonType: 'Select Size',
    }

    analyticsLogEvent('custom_event', eventDetails)
}
